"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AreaOrderingContainer = void 0;
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _AreaOrderingDetail = _interopRequireDefault(require("./AreaOrderingDetail"));
var _AreaOrderingMain = _interopRequireDefault(require("./AreaOrderingMain"));
var _areaOrderingActions = require("./areaOrderingActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 地域表示順設定機能コンテナ
 */
class AreaOrderingContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    /**
     * 一覧に戻るボタン押下時処理
     */
    _defineProperty(this, "handleListBack", search => () => {
      this.props.goMain(search);
    });
    if (props.location.state && _areaOrderingActions.CONTENTS.DETAIL === props.location.state.content) {
      props.goDetail(props.location.state.areaSortOrders);
    } else {
      props.goMain();
    }
  }
  componentWillUnmount() {
    this.props.clear();
  }
  render() {
    const {
      intl,
      pms,
      dispContent,
      detailDispKaishaCd,
      modified,
      isNewWindow
    } = this.props;
    switch (dispContent) {
      case _areaOrderingActions.CONTENTS.SEARCH:
        return /*#__PURE__*/_react.default.createElement(_AreaOrderingMain.default, {
          pms: pms,
          isNewWindow: isNewWindow
        });
      case _areaOrderingActions.CONTENTS.DETAIL:
        return /*#__PURE__*/_react.default.createElement(_AreaOrderingDetail.default, {
          pms: pms,
          kaishaCd: detailDispKaishaCd,
          btnProps: {
            backText: intl.formatMessage({
              id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
            }),
            onBack: () => this.handleListBack(modified)
          }
        });
      default:
        return null;
    }
  }
}
exports.AreaOrderingContainer = AreaOrderingContainer;
const mapStateToProps = state => {
  return {
    dispContent: state.areaOrdering.dispContent,
    areaSortOrders: state.areaOrdering.areaSortOrders,
    fromDetail: state.areaOrdering.fromDetail,
    modified: state.areaOrdering.modified
  };
};
const mapDispatchToProps = dispatch => {
  return {
    goMain: search => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.GO_MAIN](search)),
    clear: () => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.CLEAR]())
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CustomRouter.withRouter)(AreaOrderingContainer)));